require('./homeController');
require('./subscribeNow/subscribeNow');

"use strict";

angular.module('app.home', [
    'app.home.homeController',
    'app.home.subscribeNow',
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.home', {
                url: '/home',
                template: '<div ui-view=""></div>',
                controller: 'app.home.homeController',
                title: 'Home'
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/home/home.js